import React from "react";
import Header from "../components/Header";
import ImageLightboxGallery from "../components/ImageLightboxGallery";
import IntroSection from "../components/IntroSection";

import { useGalleryFeed } from '../hooks/useSyncedImages';
import GalleryLoadMore from '../components/GalleryLoadMore';
import { homeGalleryGroups } from '../data/galleries';

export default function Birthdays() {
  const feed = useGalleryFeed('images/birthday', homeGalleryGroups['Birthday Parties'], { endpoint: '/api/fetch-birthday-images', appendFallback: false });
  if (feed.loading && !feed.items.length) return <p className="text-center text-gray-600 py-10">Loading gallery...</p>;
  if (feed.error && !feed.items.length) return <p className="text-center text-red-600 py-10">Failed to load images</p>;

  return (
    <div className="font-serif">
      <Header />
      <IntroSection
        icon="🎂🎈🎉🎁"
        title="Celebrate Life's Milestones in Style"
        subtitle="From birthdays to graduations, we create joyful experiences with unforgettable decor."
      />
      <ImageLightboxGallery images={feed.items} imageLabel="Birthday" />
      <GalleryLoadMore feed={feed} />
    </div>
  );
}
